// Create a new file for weight mapping utilities
export interface WeightDivision {
  name: string;
  displayName: string;
  maxWeight: number;
}

// UFC weight divisions ordered from lightest to heaviest
export const weightDivisions: WeightDivision[] = [
  { name: 'strawweight', displayName: 'Strawweight', maxWeight: 115 },
  { name: 'flyweight', displayName: 'Flyweight', maxWeight: 125 },
  { name: 'bantamweight', displayName: 'Bantamweight', maxWeight: 135 },
  { name: 'featherweight', displayName: 'Featherweight', maxWeight: 145 },
  { name: 'lightweight', displayName: 'Lightweight', maxWeight: 155 },
  { name: 'welterweight', displayName: 'Welterweight', maxWeight: 170 },
  { name: 'middleweight', displayName: 'Middleweight', maxWeight: 185 },
  {
    name: 'light_heavyweight',
    displayName: 'Light Heavyweight',
    maxWeight: 205,
  },
  { name: 'heavyweight', displayName: 'Heavyweight', maxWeight: 265 },
];

// Extract numeric weight from fighters
export const extractWeightValue = (
  weight: number | null | undefined,
): number | null => {
  if (weight === null || weight === undefined || isNaN(weight)) return null;
  return weight;
};

// Get division from weight with enhanced error handling
export const getDivisionFromWeight = (
  weight: number | null | undefined,
): WeightDivision | null => {
  if (weight === null || weight === undefined || weight <= 0) return null;

  // Find matching division based on weight
  for (const division of weightDivisions) {
    if (weight <= division.maxWeight) {
      return division;
    }
  }

  // If weight is above all divisions, return heavyweight
  return weightDivisions[weightDivisions.length - 1];
};

// Get display name for weight with fallback
export const getWeightDisplayName = (
  weight: number | null | undefined,
): string => {
  // Get the division
  const division = getDivisionFromWeight(weight);

  if (!division) return 'Unknown Division';

  return `${division.displayName}`;
};

// Get all divisions for dropdown
export const getDivisionsForDropdown = () => {
  return [
    { value: 'all', label: 'All Divisions' },
    ...weightDivisions.map((div) => ({
      value: div.maxWeight.toString(),
      label: div.displayName,
    })),
  ];
};
